import { useApi } from '~/composables/useApi';
import displayModesEnum from '~/modules/catalog/category/enums/displayModesEnum';
import categoryContentQuery from './categoryContent.gql';
import { CategoryTree } from '~/modules/GraphQL/types';

export interface CmsBlockInterface {
  /** CMS block content */
  content?: string;
  /** CMS block identifier */
  identifier?: string;
  /** CMS block title */
  title?: string;
}

interface CmsContentInterface {
  name: string
  cmsBlock: CmsBlockInterface
  collectionContent: object
  displayMode: string
  description: string
  isShowCms: boolean
  isShowProducts: boolean
  isQuickShop: boolean,
  isClothingAndFootwear: boolean,
}

export const useCategoryContent = () => {
  const { query } = useApi();

  const getContentData = async (uid: string): Promise<CmsContentInterface> => {
    const { data } = await query<{ categoryList: CategoryTree }>(categoryContentQuery, { filters: { category_uid: { eq: uid } } });
    const category = data?.categoryList[0] ?? {};
    const name = data?.categoryList[0].name ?? "";
    const collectionContent = category?.collection_layout ?? null;
    const cmsBlock = category?.cms_block ?? { cmsBlock: { content: '' } };
    const displayMode = category?.display_mode ?? displayModesEnum.PRODUCTS;
    const description = data?.categoryList[0].description ?? "";
    const isShowCms = displayMode === displayModesEnum.PAGE || displayMode === displayModesEnum.PRODUCTS_AND_PAGE;
    const isShowProducts = displayMode === displayModesEnum.PRODUCTS || displayMode === displayModesEnum.PRODUCTS_AND_PAGE;
    const isQuickShop = data?.categoryList[0].is_quickshop ?? "";
    const isClothingAndFootwear = data?.categoryList[0].custom_class === 'CLOTHING_AND_FOOTWEAR_SUBCATEGORY';

    return {
      name,
      cmsBlock,
      collectionContent,
      displayMode,
      isShowCms,
      isShowProducts,
      isQuickShop,
      description,
      isClothingAndFootwear,
    };
  };

  return {
    getContentData,
  };
};

export default useCategoryContent;
